import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ApiResponse } from 'apisauce';
import { OkAction, ErrorAction } from './baseActions';
import { feedbackService } from '../services/feedbackAPI';
import { formatApiErrorPayload } from './utils';

type AppState = import('~/store').AppState;

export enum ServiceDeskActionType {
  SEND_SERVICE_TICKET = 'SEND_SERVICE_TICKET',
  SEND_SERVICE_TICKET_OK = 'SEND_SERVICE_TICKET_OK',
  SEND_SERVICE_TICKET_ERROR = 'SEND_SERVICE_TICKET_ERROR',
}

type SendServiceTicketAction =
  | Action<ServiceDeskActionType.SEND_SERVICE_TICKET>
  | OkAction<ServiceDeskActionType.SEND_SERVICE_TICKET_OK, void>
  | ErrorAction<ServiceDeskActionType.SEND_SERVICE_TICKET_ERROR>;

export type ServiceTicketAction = SendServiceTicketAction;

export const sendServiceTicket =
  (
    organizationId: string,
    email: string,
    subject: string,
    content: string,
    sla: string,
  ): ThunkAction<Promise<ApiResponse<void>>, AppState, null, SendServiceTicketAction> =>
  async (dispatch) => {
    dispatch({ type: ServiceDeskActionType.SEND_SERVICE_TICKET });

    const response = await feedbackService.sendServiceDeskTicket(
      organizationId,
      email,
      subject,
      content,
      sla,
    );
    if (response.ok) {
      dispatch({
        type: ServiceDeskActionType.SEND_SERVICE_TICKET_OK,
        data: response.data,
      });
    } else {
      dispatch({
        ...formatApiErrorPayload(response),
        type: ServiceDeskActionType.SEND_SERVICE_TICKET_ERROR,
      });
    }

    return response;
  };
